import Form from 'antd/lib/form'
import CustomDrawer from 'components/CustomDrawer'
import TextInput from 'components/CustomFormItem'
import CustomSelect from 'components/CustomSelect'
import styled from 'styled-components'

type TFormData = {
  email: string
  isIressCredentialsVerified: boolean | null
  clientCountTimePeriod: string | null
}

interface IReportingFilterDrawerProps {
  open: boolean
  loading: boolean
  closeDrawer: () => void
  handleSubmit: () => void
  handleFormFieldChange: (e: any) => void
  formData: TFormData
  form: any
  handleSelectChange: (name: string, value: string) => void
}

export const StyledSwitchLabel = styled.p`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #120224;
`

const ReportingFilterDrawer = ({
  open,
  closeDrawer,
  loading,
  handleSubmit,
  handleFormFieldChange,
  formData,
  form,
  handleSelectChange,
}: IReportingFilterDrawerProps) => {
  return (
    <CustomDrawer loading={loading} open={open} closeDrawer={closeDrawer} title={'Filter Users'} disableSaveButton={false} handleSubmit={handleSubmit}>
      <div>
        <Form
          form={form}
          layout="vertical"
          size="large"
          name="basic"
          onChange={handleFormFieldChange}
          initialValues={formData}
          style={{
            display: 'flex',
            flexDirection: 'column',
            rowGap: '12px',
          }}
        >
          <TextInput label="Email" name="email" placeholder="Email" />
          <StyledSwitchLabel>IRESS Status</StyledSwitchLabel>
          <CustomSelect
            disabled={false}
            onChange={handleSelectChange}
            name="isIressCredentialsVerified"
            defaultValue={formData.isIressCredentialsVerified}
            placeholder="Select Company"
            options={[
              {
                label: 'Verified',
                value: true,
              },
              {
                label: 'Not Verified',
                value: false,
              },
            ]}
            width="100%"
          />
          <StyledSwitchLabel>Client Count Time Period</StyledSwitchLabel>
          <CustomSelect
            disabled={false}
            onChange={handleSelectChange}
            name="clientCountTimePeriod"
            defaultValue={formData.clientCountTimePeriod}
            placeholder="Select Client Count Time Period"
            options={[
              {
                label: 'Last Week',
                value: 'lastWeek',
              },
              {
                label: 'Last Month',
                value: 'lastMonth',
              },
              {
                label: 'Last Year',
                value: 'lastYear',
              },
              {
                label: 'All Time',
                value: 'allTime',
              },
            ]}
            width="100%"
          />
          <TextInput label="Clients More or Equal to" name="clientsMinCount" placeholder="Clients More or Equal to" type="number" />
          <TextInput label="Clients Less or Equal to" name="clientsMaxCount" placeholder="Clients Less or Equal to" type="number" />
        </Form>
      </div>
    </CustomDrawer>
  )
}

export default ReportingFilterDrawer
